/** Sentinel values for the page layout dropdown in EditPageModal / CreatePageModal */
export const LAYOUT_SITE_DEFAULT = '__site_default__';
export const LAYOUT_NONE = '__none__';

/**
 * Map stored page layout fields to a dropdown selection value.
 *  - layoutId set + showLayout true  → specific layout UUID
 *  - layoutId null + showLayout true → site default
 *  - showLayout false                → no layout
 */
export function getLayoutDropdownValue(
  layoutId: string | null | undefined,
  showLayout: boolean
): string {
  if (!showLayout) return LAYOUT_NONE;
  if (layoutId) return layoutId;
  return LAYOUT_SITE_DEFAULT;
}

export function getLayoutSelectionFromPage(page: {
  layoutId?: string | null;
  showLayout?: boolean;
}): string {
  return getLayoutDropdownValue(page.layoutId, page.showLayout !== false);
}

export function hasPageLayoutSelectionChanged(
  initialSelection: string,
  nextSelection: string
): boolean {
  return initialSelection !== nextSelection;
}
